import { render } from "./PlbwaComponent.vue?vue&type=template&id=43539384&scoped=true"
import script from "./PlbwaComponent.vue?vue&type=script&lang=js"
export * from "./PlbwaComponent.vue?vue&type=script&lang=js"

import "./PlbwaComponent.vue?vue&type=style&index=0&id=43539384&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43539384"]])

export default __exports__